import './title.css';
export default {
  "modifiers": {
    "4xl": "pf-m-4xl",
    "3xl": "pf-m-3xl",
    "2xl": "pf-m-2xl",
    "xl": "pf-m-xl",
    "lg": "pf-m-lg",
    "md": "pf-m-md",
    "h1": "pf-m-h1",
    "h2": "pf-m-h2",
    "h3": "pf-m-h3",
    "h4": "pf-m-h4",
    "h5": "pf-m-h5",
    "h6": "pf-m-h6",
    "pageTitle": "pf-m-page-title"
  },
  "title": "pf-v6-c-title"
};